import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { isArray, concat, isEmpty } from 'lodash';
import * as Yup from 'yup';
import qs from 'querystring';

import api from '~/services/api';
import { t, number } from '~/helpers';
import { SelectDataInTable, Table } from '~/components';
import CustomSelectDataInTable from '../CustomSelectDataInTable'
import { CircularProgress } from '@material-ui/core'
import { Form } from '@unform/web';
import { Input } from '~/components/Form';

import * as S from './styles';

export default function Alteration({ data }) {
  const [initials, setInitials] = useState([]);
  const [products, setProducts] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [dataGrid, setDataGrid] = useState([])
  const [exib_justificativa, setExib_justificativa] = useState('');

  const userInfo = useSelector((state) => state.user)

  const [loading, setLoading] = useState(false)

  const [selectedProduct, setSelectedProduct] = useState({})

  const header = useMemo(
    () => [
      { id: 'prod_descricao', label: 'Produto' },
      {
        id: 'cota_total',
        label: 'Cota Total',
        format: (value) => number(value, 1),
      },
      {
        id: 'coun_cota',
        label: 'Cota Distribuir',
        format: (value) => number(value, 1),
      },
      {
        id: 'coun_saldo',
        label: 'Saldo Cota',
        format: (value) => number(value, 1),
      },
    ],
    []
  );

  const handleChangeFields = useCallback((values) => {
    if (!isEmpty(values)) {
      setProducts([values])
    } else {
      handleGetWithoutQuota()
    }

  }, [])

  const fields = useMemo(
    () => [
      {
        id: 'prod_descricao',
        label: 'Produto',
        type: 'select',
        options: products.map(({ prod_descricao }) => ({
          label: prod_descricao,
          value: prod_descricao,
        })),
        disabled: true,
      },
      {
        id: 'coun_cota',
        label: 'Cota Distribuir',
        type: 'number',
      },
      {
        id: 'coun_justificativa',
        label: 'justificativa',
        type: 'textarea',
      }
    ],
    [products, initials]
  );

  const handleValidJustificativa = useCallback((value) => {

    const regex1 = /[('")]/;

    if (regex1.test(value)) {
      return false;
    }
    return true;

  }, [])

  const schema = useMemo(
    () => ({
      prod_descricao: Yup.string()
        .typeError(t('s.geral.validacao.campoobrigatorio'))
        .required(t('s.geral.validacao.campoobrigatorio')),
      coun_cota: Yup.string()
        .typeError(t('s.geral.validacao.campoobrigatorio'))
        .required(t('s.geral.validacao.campoobrigatorio'))
        .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
        .max(7, t('s.geral.validacao.tamanhomaximo').replace('%s', 7)),
      coun_justificativa: Yup.string()
        .test('Teste caracteres', 'Caractere(s) inválido(s)', (value) => handleValidJustificativa(value))

    }),
    []
  );

  const handleGetQuotaUnit = useCallback(async () => {
    try {
      setLoading(true)
      const response = await api.get(
        `cotaunidade/${data.unid_codigo}/${data.orga_codigo}`
      );
      await setInitials(response.data.map((quota) => ({
        ...quota,
        perfil_cad: quota.usua_login_rep_cota_unid,
        perfil_tipo: quota.usua_login_rep_cota_unid_perf_codigo,
        perfil_desc: quota.usua_login_rep_cota_unid_perf_descricao,
      })));
      setLoading(false)
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data]);

  const handleGetWithoutQuota = useCallback(async () => {
    try {
      const response = await api.get(
        `cotaunidade/produtosemcota/${data.unid_codigo}/${data.orga_codigo}`
      );
      setProducts(response.data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data]);



  const handleUpdateOrDelete = useCallback(
    async (value) => {
      setExib_justificativa('')
      try {
        if (value.type === 'create') await api.post('cotaunidade', {
          orga_codigo: value.data.orga_codigo,
          orga_nome: value.data.orga_nome,
          unid_codigo: value.data.unid_codigo,
          unid_nome: value.data.unid_nome,
          prod_codigo: value.data.prod_codigo,
          prod_descricao: value.data.prod_descricao,
          cota_total: value.data.cota_total,
          coun_cota: value.data.coun_cota,
          coun_saldo: value.data.coun_saldo,
          coun_justificativa: value.data.coun_justificativa,
          usua_login_rep_cota_unid: userInfo.profile.glousuariologin,

        });
        if (value.type === 'modify') await api.put('cotaunidade', {
          orga_codigo: value.data.orga_codigo,
          orga_nome: value.data.orga_nome,
          unid_codigo: value.data.unid_codigo,
          unid_nome: value.data.unid_nome,
          prod_codigo: value.data.prod_codigo,
          prod_descricao: value.data.prod_descricao,
          cota_total: value.data.cota_total,
          coun_cota: value.data.coun_cota,
          coun_saldo: value.data.coun_saldo,
          coun_justificativa: value.data.coun_justificativa,
          usua_login_rep_cota_unid: userInfo.profile.glousuariologin,

        });
        if (value.type === 'remove') {

          await api.delete(
            `cotaunidade/${data.unid_codigo}/${data.orga_codigo}/${value.data[0].prod_codigo}`
          )

          await handleGetWithoutQuota();
        }
        toast.success('Tarefa executada com sucesso !!')
        return value.data
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));

      } finally {
        handleGetQuotaUnit();
        handleGetWithoutQuota();
      }
    },
    [products, data, dataGrid, userInfo]
  );

  const handleGetVehicleQuota = useCallback(async () => {
    try {
      if (!isEmpty(selectedProduct)) {
        const response = await api.get(`cotaveiculo`, {
          params: {
            wherefield: ['unid_codigo', 'orga_codigo', 'prod_codigo'],
            valuewherefield: [data.unid_codigo, data.orga_codigo, selectedProduct.prod_codigo],
            typewherefield: ['EQUALS', 'EQUALS', 'EQUALS'],
            pagesize: 9999,
          },
          paramsSerializer: (param) => qs.stringify(param),
        });
        setVehicles(response.data.items);
      } else {
        setVehicles([])
      }

    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data, selectedProduct]);


  useEffect(() => {
    handleGetQuotaUnit();
    handleGetVehicleQuota();
  }, [data]);

  useEffect(() => {
    handleGetVehicleQuota();
  }, [selectedProduct])

  useEffect(() => {
    handleGetWithoutQuota();
  }, [data])


  if (isEmpty(data)) return <div />;

  return (
    <>
      {loading ?
        <S.LoadingWrapper>
          <CircularProgress
            size={30}
            color="primary"
          // style={{ margin: '10px' }}
          />
        </S.LoadingWrapper>
        :
        <S.Wrapper>
          <CustomSelectDataInTable
            title={`Cotas da Unidade: ${data.unid_nome}`}
            size="small"
            unique="prod_codigo"
            maxWidth="xs"
            cells={header}
            initials={initials}
            fields={fields}
            onChanged={() => undefined}
            onField={(value) => {

              let tempObject = {
                ...concat(products, initials).find(
                  (product) => product.prod_descricao === value.prod_descricao
                ),
                ...value,
              }
              return tempObject

            }}
            schema={schema}
            onCallback={(value) => handleUpdateOrDelete(value)}
            onOpenForm={(value) => handleChangeFields(value)}
            onRow={(value) => {
              setSelectedProduct(value)
              setExib_justificativa(value.coun_justificativa)
            }}
            radio
            userPerfil={userInfo.profile}
          />

          {exib_justificativa && <Form>
            <Input
              name="justificativa_exib"
              label="Justificativa"
              disabled
              value={exib_justificativa}
              multiline
              rows={4}
            />
          </Form>}

          <Table
            title="Veículos com Cota:"
            cells={[
              { id: 'veic_placa', label: 'Placa' },
              {
                id: 'cove_cota',
                label: 'Cota',
                format: (value) => number(value, 1),
                align: 'right',
              },
              {
                id: 'cove_saldo',
                label: 'Saldo',
                format: (value) => number(value, 1),
                align: 'right',
              },
            ]}
            data={vehicles}
            size="small"
          />
        </S.Wrapper>
      }

    </>
  );
}

Alteration.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
